import { createSlice } from "@reduxjs/toolkit";

const busapixxSlice = createSlice({
  name: "busapi",
  initialState: {
    token: null,
  },
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const { setToken } = busapixxSlice.actions;
export default busapixxSlice.reducer;


export const getToken = (state) => {
  return state.busapi.token;
};
